import Vue from 'vue';
import Router from 'vue-router';
import authMiddleware from '@/router/middlewares/authMiddleware';

// Login Module
import LoginForm from '_common/components/forms/LoginForm.vue';
import FeedToken from '_common/components/forms/FeedToken.vue';
import ChangePassForm from '_common/components/forms/NewPassForm.vue';
import RecoverPassForm from '_common/components/forms/RecoverPassForm.vue';
// Setting Module
import Dashboard from '@/app/views/Dashboard.vue';
import UserProfileLite from '_modules/settings/views/UserProfileLite.vue';
// Error View
import Errors from '@/app/views/Errors.vue';

import { fetchModulesRoutes } from '_utils/require';
// eslint-disable-next-line
const modules = fetchModulesRoutes( require.context('_modules', true, /routes\.js$/) );

// eslint-disable-next-line
const Login = r => require(['@/app/views/Login.vue'], r);// eslint-disable-next-line
const Admin = r => require(['@/app/views/Admin.vue'], r);// eslint-disable-next-line

Vue.use(Router);

export default new Router({
  mode: 'history',
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/public',
      component: Login,
      redirect: '/public/login',
      children: [
        {
          path: 'login',
          component: LoginForm,
        },
        {
          path: 'change-password/:token',
          component: ChangePassForm,
        },
        {
          path: 'recover-password/:token',
          component: RecoverPassForm,
        },
        {
          path: 'feed/token',
          component: FeedToken,
        },
      ],
    },
    {
      path: '/admin',
      beforeEnter: authMiddleware,
      component: Admin,
      redirect: 'overview',
      children: [
        {
          path: 'overview',
          name: 'admin-overview',
          component: Dashboard,
        },
        {
          path: 'perfil',
          name: 'admin-perfil',
          component: UserProfileLite,
        },
        ...modules,
      ],
    },
    {
      path: '/errors',
      name: 'errors',
      component: Errors,
    },
    {
      path: '*',
      redirect: '/admin/overview/',
    },
  ],
});
